import React, { ReactNode, ReactNodeArray } from "react";
import { Container, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

type PageProps = {
  children: ReactNode | ReactNodeArray;
  withoutContainer?: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    position: "relative",
    "&::before": {
      content: '""',
      width: "50%",
      backgroundColor: theme.palette.common.white,
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      zIndex: -1,
    },
    "&::after": {
      content: '""',
      width: "50%",
      backgroundColor: theme.palette.background.default,
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: -1,
    },
    [theme.breakpoints.down('md')]: {
      "&::before": {
        backgroundColor: theme.palette.background.default,
      },
    },
  },
  innerContainer: {
    height: "100%",
  },
  content: {
    display: "flex",
    height: "100%",
    [theme.breakpoints.down('md')]: {
      flexDirection: "column",
    },
  },
}));

const Page: React.FC<PageProps> = ({ children, withoutContainer = false }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {withoutContainer && <div className={classes.content}>{children}</div>}
      {!withoutContainer && (
        <Container classes={{ root: classes.innerContainer }}>
          <div className={classes.content}>{children}</div>
        </Container>
      )}
    </div>
  );
};

export default Page;
